import { createContext, useState, useEffect, ReactNode } from "react";
import { isDateFormat } from "@/shared/lib/user-setting";

export type DateFormat = "YYYY-MM-DD" | "DD/MM/YYYY" | "MM/DD/YYYY";

const DATE_FORMAT_STORAGE_KEY = "dateFormat";
const DEFAULT_DATE_FORMAT: DateFormat = "YYYY-MM-DD";

interface DateFormatContextType {
  dateFormat: DateFormat;
  setDateFormat: (format: DateFormat) => void;
}

export const DateFormatContext = createContext<DateFormatContextType | undefined>(
  undefined
);

export const DateFormatProvider = ({ children }: { children: ReactNode }) => {
  const [dateFormat, setDateFormatState] = useState<DateFormat>(() => {
    const stored = localStorage.getItem(DATE_FORMAT_STORAGE_KEY);
    return isDateFormat(stored) ? stored : DEFAULT_DATE_FORMAT;
  });

  useEffect(() => {
    localStorage.setItem(DATE_FORMAT_STORAGE_KEY, dateFormat);
  }, [dateFormat]);

  const setDateFormat = (format: DateFormat) => {
    setDateFormatState(format);
  };

  return (
    <DateFormatContext.Provider value={{ dateFormat, setDateFormat }}>
      {children}
    </DateFormatContext.Provider>
  );
};

